"use client";
import { motion } from "framer-motion";

export function ReviewsHero() {
  return (
    <section
      id="reviews-hero"
      data-header-scheme="dark"
      className="pt-32 pb-24 bg-foreground/5 dark:bg-card/30 transition-colors"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="font-serif text-4xl md:text-6xl font-light text-foreground mb-6 tracking-tight">
            Customer Reviews
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See what our customers say about their Concretta microcement
            experience
          </p>
        </motion.div>
      </div>
    </section>
  );
}
